export default {"src":"/_next/static/media/CM2024-DailyDeals-ProductPage-Gif.fe444db5.gif","height":200,"width":600,"blurWidth":0,"blurHeight":0};